import { Switch } from '@material-tailwind/react'
import React from 'react'


export default function ASwitch({ v }) {
    return (
        <>
            {!v.data.hide && <div className={`flex flex-row gap-3 my-2 ${v.data?.className}`}>
                {!v.data?.isStyle && <p className="text-base text-black font-bold amiriB">{v.data?.label}</p>}
                <Switch id="test" defaultChecked={v.data?.status === 1 ? true : false} color="red" {...v.register('status', { required: v.data.required })} />
                {v.errors[v.data?.name] && v.data.errorMsg && <small className="text-red-600">{v.data.errorMsg}</small>}
            </div>}
        </>
    )
}
